/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockStocktakeEditareasCtrl
 */
angular.module('mercury.modules.stock.stocktake')
.controller('StockStocktakeEditareasCtrl', ["dialog", "$q", "$scope", "$stateParams", "Stocktakes", "StocktakeTemplates", "title", function(dialog, $q, $scope, $stateParams, Stocktakes, StocktakeTemplates, title) {
  var areaTemplates = StocktakeTemplates.getAllAreaTemplates($stateParams.id);
  $scope.areas = Stocktakes.getAreas($stateParams.id);

  $scope.stocktake = Stocktakes.get($stateParams.id);
  $scope.stocktake.then(function(stocktake) {
    $scope.stocktake = stocktake;

    title.set('Stocktake Areas for ' + $scope.stocktake.title);
  }, function() {
    $state.go('Stock.Stocktakes');
  });

  $scope.areaOptions = [];
  var updateAreaOptions = function() {
    var existingAreas = {};
    angular.forEach($scope.areas, function(area) {
      existingAreas[area.templateId] = true;
    });

    $scope.areaOptions = [];
    angular.forEach(areaTemplates, function(template) {
      if (!existingAreas[template.id]) {
        $scope.areaOptions.push(template);
      }
    });
  };

  $scope.stocktakeId = $stateParams.id;

  $scope.loadingPromise = $q.all([
    areaTemplates.$promise,
    $scope.areas.$promise,
    $scope.stocktake
  ]);

  $scope.loadingPromise.then(function() {
    updateAreaOptions();
  });

  $scope.addArea = function(areaTemplate) {
    $scope.addingArea = true;
    Stocktakes.createArea($stateParams.id, areaTemplate.id)
    .then(function(result) {
      $scope.addingArea = false;
      $scope.areas.push(result);
      updateAreaOptions();
    }, function() {
      $scope.addingArea = false;
    });
  };

  $scope.deleteArea = function(area, index) {
    Stocktakes.removeArea(area)
    .then(function() {
      $scope.areas.splice(index, 1);
      updateAreaOptions();
    });
  };
}]);
